import { Box, Typography } from "@mui/material"
import { useNavigate, useSearch } from "@tanstack/react-router"
import React, { useCallback } from "react"

import { ManagerChips } from "@/components/common/Filters/ManagerChips"
import { StatusChips } from "@/components/common/Filters/StatusChip"
import type { CompanyListFilter, CompanyStatus } from "@/graphql/codegen/graphql"
import { useManagers } from "@/hooks/api/useManagers"

export const SupplierReportrSearchFilterChips: React.FC = () => {
  const navigate = useNavigate({ from: "/app/procurement/_layout/supplier-report" })
  const { statuses, managers } = useSearch({ from: "/app/procurement/_layout/supplier-report", strict: true })
  const { visibleManagers } = useManagers()
  const handleRemoveFilter = useCallback(
    (key: keyof CompanyListFilter, value: string | CompanyStatus) => {
      void navigate({
        search: (prev: CompanyListFilter) => {
          const newFilter = { ...prev }

          if (Array.isArray(newFilter[key])) {
            ;(newFilter[key] as (string | CompanyStatus)[]) = (newFilter[key] as (string | CompanyStatus)[]).filter(
              (item) => item !== value
            )
            if ((newFilter[key] as (string | CompanyStatus)[]).length === 0) {
              delete newFilter[key]
            }
          } else {
            delete newFilter[key]
          }

          return newFilter
        },
        replace: true,
      })
    },
    [navigate]
  )

  if (!statuses && !managers) {
    return null
  }

  return (
    <Box data-testid='company-search-filter-chips' display='flex' flexWrap='wrap' alignItems='center' gap={2}>
      <Typography variant='body1'>Filters:</Typography>
      <StatusChips
        statuses={statuses}
        onRemove={(key, value) => handleRemoveFilter(key as keyof CompanyListFilter, value)}
      />
      <ManagerChips managerIds={managers || []} managerOptions={visibleManagers} onRemove={handleRemoveFilter} />
    </Box>
  )
}
